export * from './breadcrumb.component';

export * from './generate-table/generate-table.component';
export * from './generate-table/generate-table.model';

export * from './img-dialog.component';
export * from './remove-dialog/remove.dialog';
export * from './remove-dialog/remove.dialog.service';

export * from './select-beneficiaria/select-beneficiaria.component';
